import { Flex, Spin } from 'antd'
import { FC, PropsWithChildren } from 'react'

type Props = {
  isLoading: boolean
  className?: string
} & PropsWithChildren

const ComponentWithSpinner: FC<Props> = ({ children, isLoading, className }) => {
  if (isLoading) {
    return (
      <Flex className={`w-full h-full ${className}`} justify="center" align="center">
        <Spin size="large" spinning />
      </Flex>
    )
  }

  return <>{children}</>
}

export default ComponentWithSpinner
